import * as XLSX from "xlsx";

/**
 * Generates an Excel file from a given JSON array with word wrapping for long content.
 *
 * @param {Array<Object>} data - The JSON array to be exported.
 * @param {string} sheetName - The name of the sheet in the Excel file.
 * @param {string} fileName - The name of the Excel file to be downloaded.
 * @param {number} wrapLimit - The character limit after which content is wrapped.
 */
export function exportToExcelAll(data, sheetName = "Sheet1", fileName = "Report.xlsx", wrapLimit = 20) {
  if (!Array.isArray(data) || data.length === 0) {
    console.error("Invalid data: Please provide a non-empty array.");
    return;
  }

  // Wrap text in cells if the content exceeds the wrapLimit
  const wrappedData = data.map((row) => {
    const newRow = {};
    Object.keys(row).forEach((key) => {
      const value = row[key];
      if (value && value.toString().length > wrapLimit) {
        // Insert newline characters for wrapping
        newRow[key] = value.toString().match(new RegExp(`.{1,${wrapLimit}}`, 'g')).join('\n');
      } else {
        newRow[key] = value;
      }
    });
    return newRow;
  });

  // Create worksheet with wrapped data
  const worksheet = XLSX.utils.json_to_sheet(wrappedData);

  // Compute column widths
  const headers = Object.keys(data[0]);
  const colWidths = headers.map((header) => {
    const maxContentLength = wrappedData.reduce((max, row) => {
      const cellContent = row[header] ? row[header].toString() : "";
      return Math.max(max, cellContent.length);
    }, header.length);

    return { wch: maxContentLength + 2 }; // Adding padding for better spacing
  });
  worksheet["!cols"] = colWidths;

  // Enable word wrapping
  worksheet["!rows"] = wrappedData.map(() => ({ hpx: 20 })); // Adjust row height

  // Create workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Write the Excel file
  XLSX.writeFile(workbook, fileName);
}
